<template>
	<Modal
		v-if="showExitIntentModal"
		:max-width="'max-w-[440px]'"
		:hide-actions="true"
		:allow-close="false"
		:remove-padding="true"
		rounded-size="rounded-[20px]"
		:prevent-scrolling="false"
		@modal:close="onStay"
	>
		<template #body>
			<div class="flex justify-center bg-won-light-violet py-5">
				<AutoApplyLockup class="h-8 w-auto" />
			</div>

			<div class="px-6 pt-5 pb-6 font-[Inter] text-won-blue">
				<h2 class="text-center text-[22px] leading-tight font-bold">
					Try AutoApply before you go
				</h2>
				<p class="mt-3 text-center text-sm leading-relaxed text-won-dark-blue">
					AutoApply fills in the application form for you! Review, adjust if needed, and
					submit. Try it on one job before you explore the rest.
				</p>

				<button
					type="button"
					class="mt-6 w-full rounded-md bg-won-green px-4 py-2.5 text-sm font-semibold text-white hover:bg-won-green/90"
					@click="onStay"
				>
					Finish My First Application
				</button>
				<button
					type="button"
					class="mt-2 w-full rounded-md px-4 py-2.5 text-sm font-semibold text-won-dark-blue hover:bg-[#F5F5F5]"
					@click="onLeave"
				>
					Leave Anyway
				</button>
			</div>
		</template>
	</Modal>
</template>

<script setup>
import { storeToRefs } from 'pinia';

import Modal from '../../components/modal.vue';
import AutoApplyLockup from '../../icons/auto-apply-lockup.vue';
import { useOnboardingRetentionStore } from '../../store/onboarding-retention.store';

const retentionStore = useOnboardingRetentionStore();
const { showExitIntentModal } = storeToRefs(retentionStore);

const onStay = () => retentionStore.cancelStay();
const onLeave = () => retentionStore.confirmLeave();
</script>
